// Update exchangeRate.js to handle USD properly

import { CURRENCIES } from './constants';

const API_URL = 'https://api.exchangerate-api.com/v4/latest/USD';
let cachedRates = null;
let cacheTime = 0;
const CACHE_DURATION = 3600000;

export const fetchExchangeRates = async () => {
  const now = Date.now();
  
  if (cachedRates && (now - cacheTime) < CACHE_DURATION) {
    return cachedRates;
  }

  try {
    const response = await fetch(API_URL);
    if (!response.ok) {
      throw new Error('Failed to fetch exchange rates');
    }
    const data = await response.json();
    
    // Ensure USD is always 1
    data.rates.USD = 1;
    
    cachedRates = data.rates;
    cacheTime = now;
    
    return cachedRates;
  } catch (error) {
    console.error('Error fetching exchange rates:', error);
    return getFallbackRates();
  }
};

const getFallbackRates = () => {
  return {
    USD: 1,
    NGN: 1500,
    GHS: 12,
    KES: 130,
    ZAR: 18,
    EUR: 0.92,
    GBP: 0.79,
    CAD: 1.35,
    AUD: 1.52,
    JPY: 148,
    CNY: 7.24,
    INR: 83,
    BRL: 4.90,
  };
};

export const getExchangeRate = async (currencyCode = 'NGN') => {
  const rates = await fetchExchangeRates();
  return rates[currencyCode] || 1500;
};

export const toXPUNT = async (amount, currencyCode = 'NGN') => {
  // $XPUNT is pegged to USD (1 $XPUNT = 1 USD)
  const usdRate = await getExchangeRate('USD');
  const localRate = await getExchangeRate(currencyCode);
  // Convert local currency to USD first, then to $XPUNT
  const usdAmount = amount / localRate * usdRate;
  return usdAmount;
};

export const fromXPUNT = async (amount, currencyCode = 'NGN') => {
  // $XPUNT to local currency (1 $XPUNT = 1 USD)
  const localRate = await getExchangeRate(currencyCode);
  return amount * localRate;
};

export const useExchangeRate = (currencyCode = 'NGN') => {
  const [rate, setRate] = useState(1500);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRate = async () => {
      try {
        setLoading(true);
        const result = await getExchangeRate(currencyCode);
        setRate(result);
        setError(null);
      } catch (err) {
        setError(err.message);
        setRate(1500);
      } finally {
        setLoading(false);
      }
    };
    fetchRate();
  }, [currencyCode]);

  return { rate, loading, error, refresh: fetchRate };
};

export default {
  fetchExchangeRates,
  getExchangeRate,
  toXPUNT,
  fromXPUNT,
  useExchangeRate,
};